import React, { Component } from 'react';
import { Row, Col, Button, Form, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'
import LedenOverviewResults from './Results'
import LedenButtons from './Buttons'
import Api from '../../../Global/Modules/Api'
import {  getYearOptionsPlus } from '../../../Member/Modules/services/dateServices';
const FETCH_URL = "api/companies/admin/companymembers"


class LedenOverzicht extends Component {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleSortingClick = this.handleSortingClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeSearch = this.handleChangeSearch.bind(this);
        this.handleClickSearch = this.handleClickSearch.bind(this);
        this.handleChangePageSize = this.handleChangePageSize.bind(this)
        this.handleClickExcel1 = this.handleClickExcel1.bind(this);
        this.handleClickExcel2 = this.handleClickExcel2.bind(this);
        this.handleClickExcel3 = this.handleClickExcel3.bind(this);
        this.handleClickExcel4 = this.handleClickExcel4.bind(this);
        this.handleClickExcel5 = this.handleClickExcel5.bind(this);
        this.handleClickExcel6 = this.handleClickExcel6.bind(this);
        this.state = {
            IdOld: "sorting",
            LastName: "sorting",
            Email: "sorting",
            Status: "sorting",
            Ke: "sorting",
            Pe: "sorting",
            DateSort: "sorting",
            members: [],
            companies: [],
            groups: [],
            value: '',
            displayTable: 'none',
            emptyTable: 'none',
            companySelected: 0,
            memberStatus: 7,
            searchWord: '',
            companySearchable: '',
            groupSelected: 0,
            newsletter: '',
            status: '',
            accord: '',
            hertoetsing:'',
            pagination: {
                totalPages: 0,
                currentPage: 0,
                pageSize: 0,
                totalCount: 0,
                orderBy: ""
            }
        }
    }
    handleChangePageSize(e) {
        this.setState({ pagination: { ...this.state.pagination, pageSize: e.target.value } })
        Api.PostTableApi(FETCH_URL + "?PageSize=" + e.target.value + (this.state.pagination.orderBy == "" ? "" : "&OrderBy=" + this.state.pagination.orderBy), {}, this.props.history, this.handleClick).then(response => {
            if (response.pagination.totalCount === 0) {
                this.setState({ displayTable: "none" })
                this.setState({ emptyTable: "block" })
            } else {
                this.setState({ displayTable: "block" })
                this.setState({ emptyTable: "none" })
            }
            this.setState({ pagination: response.pagination })
            return response.data.json()
        }).then(objectData => {
            if (objectData !== undefined)
                this.setState({ members: objectData.companies });
        })

    }
    handleSortingClick(e) {
        var columnName = e;
        var newSort = this.state.pagination.orderBy.indexOf(e) >= 0 ? this.state.pagination.orderBy.indexOf("asc") >= 0 ? this.state.pagination.orderBy.replace("asc", "desc") : this.state.pagination.orderBy.replace("desc", "asc") : e + " asc";
        this.setState({ IdOld: "sorting" })
        this.setState({ LastName: "sorting" })
        this.setState({ Email: "sorting" })
        this.setState({ Status: "sorting" })
        this.setState({ Ke: "sorting" })
        this.setState({ Pe: "sorting" })
        this.setState({ DateSort: "sorting" })
        this.setState({ [columnName]: newSort.indexOf("asc") >= 0 ? "sorting_asc" : "sorting_desc" })
        this.setState({ pagination: { ...this.state.pagination, orderBy: newSort } })
        var body = {
            searchWord: this.state.searchWord,
            companySelected: this.state.companySelected,
            groupSelected: this.state.groupSelected,
            memberStatus: this.state.memberStatus,
            companySearchable: this.state.companySearchable,
            newsletter: this.state.newsletter,
            accord: this.state.accord,
            hertoetsing: this.state.hertoetsing,
            status: this.state.status,
        }
        Api.PostTableApi(FETCH_URL + "?OrderBy=" + newSort + "&PageSize=" + this.state.pagination.pageSize, body, this.props.history, this.handleClick).then(response => {
            if (response.pagination.totalCount === 0) {
                this.setState({ displayTable: "none" })
                this.setState({ emptyTable: "block" })
            } else {
                this.setState({ displayTable: "block" })
                this.setState({ emptyTable: "none" })
            }
            this.setState({ pagination: response.pagination })
            return response.data.json()
        }).then(objectData => {
            if (objectData !== undefined)
                this.setState({ members: objectData.companies });
        })
    }


    handleClick(e) {
        const FETCH_URL2 = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        var body = {
            searchWord: this.state.searchWord,
            companySelected: this.state.companySelected,
            groupSelected: this.state.groupSelected,
            memberStatus: this.state.memberStatus,
            companySearchable: this.state.companySearchable,
            newsletter: this.state.newsletter,
            accord: this.state.accord,
            hertoetsing: this.state.hertoetsing,
            status: this.state.status
        }
        Api.PostTableApi(FETCH_URL2, body, this.props.history, this.handleClick).then(response => {
            if (response.pagination.totalCount === 0) {
                this.setState({ displayTable: "none" })
                this.setState({ emptyTable: "block" })
            } else {
                this.setState({ displayTable: "block" })
                this.setState({ emptyTable: "none" })
            }
            this.setState({ pagination: response.pagination })
            return response.data.json()
        }).then(objectData => {
            if (objectData !== undefined)
                this.setState({ members: objectData.companies });
        })
    }
    handleChangeSearch(e) {
        this.setState({ [e.target.name]: e.target.value })
    }
    handleClickSearch(e) {
        var body = {
            searchWord: this.state.searchWord,
            companySelected: this.state.companySelected,
            groupSelected: this.state.groupSelected,
            memberStatus: this.state.memberStatus,
            companySearchable: this.state.companySearchable,
            newsletter: this.state.newsletter,
            accord: this.state.accord,
            hertoetsing: this.state.hertoetsing,
            status: this.state.status
        }
        Api.PostTableApi(FETCH_URL + "?OrderBy=" + this.state.pagination.orderBy + "&PageSize=" + this.state.pagination.pageSize, body, this.props.history, this.handleClick).then(response => {
            if (response.pagination.totalCount === 0) {
                this.setState({ displayTable: "none" })
                this.setState({ emptyTable: "block" })
            } else {
                this.setState({ displayTable: "block" })
                this.setState({ emptyTable: "none" })
            }
            this.setState({ pagination: response.pagination })
            return response.data.json()
        }).then(objectData => {
            if (objectData !== undefined)
                this.setState({ members: objectData.companies });
        })
    }
    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value })
        var body = {
            searchWord: this.state.searchWord,
            companySelected: this.state.companySelected,
            groupSelected: this.state.groupSelected,
            memberStatus: this.state.memberStatus,
            companySearchable: this.state.companySearchable,
            newsletter: this.state.newsletter,
            accord: this.state.accord,
            hertoetsing: this.state.hertoetsing,
            status: this.state.status,
            [e.target.name]: e.target.value
        }
        Api.PostTableApi(FETCH_URL, body, this.props.history, this.handleClick).then(response => {
            if (response.pagination.totalCount === 0) {
                this.setState({ displayTable: "none" })
                this.setState({ emptyTable: "block" })
            } else {
                this.setState({ displayTable: "block" })
                this.setState({ emptyTable: "none" })
            }
            this.setState({ pagination: response.pagination })
            return response.data.json()
        }).then(objectData => {
            if (objectData !== undefined)
                this.setState({ members: objectData.companies });
        })
    }
    handleClickExcel1(e) {
        var body = {
            searchWord: this.state.searchWord,
            companySelected: this.state.companySelected,
            groupSelected: this.state.groupSelected,
            memberStatus: this.state.memberStatus,
            companySearchable: this.state.companySearchable,
            newsletter: this.state.newsletter,
            accord: this.state.accord,
            hertoetsing: this.state.hertoetsing,
            status: this.state.status,
        }
        Api.PostApiDownloadFile("api/members/admin/memberExcelExport/?ExportType=AD", body, this.props.history, this.handleClick).then(response => {
            var fileDownload = require('js-file-download');
            fileDownload(response, 'Adreslijst.xlsx');
        });
    }
    handleClickExcel2(e) {
        var body = {
            searchWord: this.state.searchWord,
            companySelected: this.state.companySelected,
            groupSelected: this.state.groupSelected,
            memberStatus: this.state.memberStatus,
            companySearchable: this.state.companySearchable,
            newsletter: this.state.newsletter,
            accord: this.state.accord,
            hertoetsing: this.state.hertoetsing,
            status: this.state.status,
        }
        Api.PostApiDownloadFile("api/members/admin/memberExcelExport/?ExportType=CLk", body, this.props.history, this.handleClick).then(response => {
            var fileDownload = require('js-file-download');
            fileDownload(response, 'Checklist KE en werkervaring.xlsx');
        });
    }
    handleClickExcel3(e) {
        var body = {
            searchWord: this.state.searchWord,
            companySelected: this.state.companySelected,
            groupSelected: this.state.groupSelected,
            memberStatus: this.state.memberStatus,
            companySearchable: this.state.companySearchable,
            newsletter: this.state.newsletter,
            accord: this.state.accord,
            hertoetsing: this.state.hertoetsing,
            status: this.state.status,
        }
        Api.PostApiDownloadFile("api/members/admin/memberExcelExport/?ExportType=CLp", body, this.props.history, this.handleClick).then(response => {
            var fileDownload = require('js-file-download');
            fileDownload(response, 'Checklist PE en DWE.xlsx');
        });
    }
    handleClickExcel4(e) {
        var body = {
            searchWord: this.state.searchWord,
            companySelected: this.state.companySelected,
            groupSelected: this.state.groupSelected,
            memberStatus: this.state.memberStatus,
            companySearchable: this.state.companySearchable,
            newsletter: this.state.newsletter,
            accord: this.state.accord,
            hertoetsing: this.state.hertoetsing,
            status: this.state.status,
        }
        Api.PostApiDownloadFile("api/members/admin/memberExcelExport/?ExportType=ADp", body, this.props.history, this.handleClick).then(response => {
            var fileDownload = require('js-file-download');
            fileDownload(response, 'Adreslijst PE en DWE.xlsx');
        });
    }
    handleClickExcel5(e) {
        var body = {
            searchWord: this.state.searchWord,
            companySelected: this.state.companySelected,
            groupSelected: this.state.groupSelected,
            memberStatus: this.state.memberStatus,
            companySearchable: this.state.companySearchable,
            newsletter: this.state.newsletter,
            accord: this.state.accord,
            hertoetsing: this.state.hertoetsing,
            status: this.state.status,
        }
        Api.PostApiDownloadFile("api/members/admin/memberExcelExport/?ExportType=TO", body, this.props.history, this.handleClick).then(response => {
            var fileDownload = require('js-file-download');
            fileDownload(response, 'Totaallijst.xlsx');
        });
    }
    handleClickExcel6(e) {
        var body = {
            searchWord: this.state.searchWord,
            companySelected: this.state.companySelected,
            groupSelected: this.state.groupSelected,
            memberStatus: this.state.memberStatus,
            companySearchable: this.state.companySearchable,
            newsletter: this.state.newsletter,
            accord: this.state.accord,
            hertoetsing: this.state.hertoetsing,
            status: this.state.status,
        }
        Api.PostApiDownloadFile("api/members/admin/memberExcelExport/?ExportType=OV", body, this.props.history, this.handleClick).then(response => {
            var fileDownload = require('js-file-download');
            fileDownload(response, 'Overzicht factuuradressen.xlsx');
        });
    }
    componentWillMount() {
        Api.GetApi("api/companies/adminNopagination").then(data => {
            let comps = data.companies.map(function (item, index) {
                return <option value={item.id}>{item.name}</option>
            })
            this.setState({ companies: comps });
        });
        Api.GetApi("api/companies/groups").then(data => {
            let comps = data.groups.map(function (item, index) {
                return <option value={item.id}>{item.name}</option>
            })
            this.setState({ groups: comps });
        });
        Api.PostTableApi(FETCH_URL, {}, this.props.history, this.handleClick).then(response => {
            if (response.pagination.totalCount === 0) {
                this.setState({ displayTable: "none" })
                this.setState({ emptyTable: "block" })
            } else {
                this.setState({ displayTable: "block" })
                this.setState({ emptyTable: "none" })
            }
            this.setState({ pagination: response.pagination })
            return response.data.json()
        }).then(objectData => {
            if (objectData !== undefined)
                this.setState({ members: objectData.companies });
        })
        //}

    }

    render() {
        return (
            <div>
                <Row>
                    <Col md={6} sm={12}>
                        <Form inline>
                            <FormGroup controlId="formInlineName">
                                <ControlLabel>Zoek</ControlLabel>{' '}
                                <FormControl type="text" name='searchWord' placeholder="lidnr/naam/e-mail/company" onChange={this.handleChangeSearch} />
                            </FormGroup>{' '}
                            <Button type="button" onClick={this.handleClickSearch}>Zoeken</Button>
                        </Form>
                    </Col>
                    <Col md={6} sm={12}>
                        <LedenButtons />
                    </Col>
                </Row>
                <hr />
                <Form horizontal id="filteringForm">
                    <Row>
                        <Col sm={4}>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={6}>
                                    status lid
                            </Col>
                                <Col sm={6}>
                                    <FormControl name='memberStatus' componentClass="select" placeholder="select" onChange={this.handleChange}>
                                        <option value="7">select</option>
                                        <option value="0">ASP</option>
                                        <option value="1">RC</option>
                                        <option value="2">RO</option>
                                        <option value="3">RT a</option>
                                        <option value="4">RT b</option>
                                        <option value="5">AFG</option>
                                        <option value="6">NON-Actief</option>
                                    </FormControl>
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail" onChange={this.handleChange}>
                                <Col componentClass={ControlLabel} sm={6}>
                                    status toestemming bedrijf
                            </Col>
                                <Col sm={6}>
                                    <FormControl name='companySearchable' componentClass="select" placeholder="select" onChange={this.handleChange}>
                                        <option value="">select</option>
                                        <option value="ja">ja</option>
                                        <option value="ne">nee</option>
                                    </FormControl>
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={6}>
                                    naam bedrijf
                            </Col>
                                <Col sm={6}>
                                    <FormControl name='companySelected' componentClass="select" placeholder="select" onChange={this.handleChange}>
                                        <option value="0">select</option>
                                        {this.state.companies}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={4}>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={6}>
                                    status aanvraag
                            </Col>
                                <Col sm={6}>
                                    <FormControl name='status' componentClass="select" placeholder="select" onChange={this.handleChange}>
                                        <option value="">select</option>
                                        <option value="rc">op voor RC</option>
                                        <option value="ro">op voor RO</option>
                                        <option value="rta">op voor RT a</option>
                                        <option value="rtb">op voor RT b</option>
                                    </FormControl>
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={6}>
                                    kennis geaccordeerd
                            </Col>
                                <Col sm={6}>
                                    <FormControl name='accord' componentClass="select" placeholder="select" onChange={this.handleChange}>
                                        <option value="">select</option>
                                        <option value="ja">ja</option>
                                        <option value="nee">nee</option>
                                    </FormControl>
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={6}>
                                    jaartal hertoetsing
                            </Col>
                                <Col sm={6}>
                                    <FormControl name='hertoetsing' componentClass="select" placeholder="select" onChange={this.handleChange}>
                                        <option value="">-- jaar --</option>
                                        {getYearOptionsPlus()}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={4}>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={6} onChange={this.handleChange}>
                                    groep
                            </Col>
                                <Col sm={6}>
                                    <FormControl name='groupSelected' componentClass="select" placeholder="select" onChange={this.handleChange}>
                                        <option value="0">select</option>
                                        {this.state.groups}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="formHorizontalEmail">
                                <Col componentClass={ControlLabel} sm={6} onChange={this.handleChange}>
                                    nieuwsbrief
                            </Col>
                                <Col sm={6}>
                                    <FormControl name='newsletter' componentClass="select" placeholder="select" onChange={this.handleChange}>
                                        <option value="">select</option>
                                        <option value="ja">ja</option>
                                        <option value="nee">nee</option>
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                </Form>
                <hr />
                <Row>
                    <Col md={12} sm={12}>
                        <Form inline>
                            <Button onClick={this.handleClickExcel1}>
                                Adreslijst
                        </Button>
                            <Button onClick={this.handleClickExcel2}>
                                Checklist KE en werkervaring
                        </Button>
                            <Button onClick={this.handleClickExcel3}>
                                Checklist PE en DWE
                        </Button>
                            <Button onClick={this.handleClickExcel4}>
                                Adreslijst PE en DWE
                        </Button>
                            <Button onClick={this.handleClickExcel5}>
                                Totaallijst
                        </Button>
                            <Button onClick={this.handleClickExcel6}>
                                Overzicht factuuradressen
                        </Button>
                        </Form>
                    </Col>
                </Row>

                <hr />
                <h4><strong>Overzicht leden</strong></h4>
                <p>Zoek voor leden of gebruik de filters om leden te tonen.</p>
                <Row>
                    <Col md={1} sm={1}>
                        <FormControl name='pageSize' componentClass="select" placeholder="select" onChange={this.handleChangePageSize} value={this.state.pagination.pageSize}>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="0">All</option>
                        </FormControl>
                    </Col>
                </Row>
                <LedenOverviewResults companies={this.state.members} pagination={this.state.pagination} fnc={this.handleClick} sortfnc={this.handleSortingClick} columns={this.state} />
            </div>
        );
    }
}

export default LedenOverzicht;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Overview.js